import { createFileRoute } from "@tanstack/react-router";

import { MyFiles } from "@/features/my-files";
import { myFilesSearchSchema } from "@/features/my-files/page-search-schema";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/my-files/")({
  component: RouteComponent,
  validateSearch: myFilesSearchSchema,
});

function RouteComponent() {
  usePageTitle("My Files");

  return <MyFiles />;
}
